/**
 * @file AppTopbar — global topbar with search + notifications + nueva-cita.
 * Markup mirrors design's `cd-topbar`. Hidden on mobile via design CSS.
 */
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationsMenu, { usePendingCount } from "./NotificationsMenu";

const Icon = {
  Search: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  ),
  Bell: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </svg>
  ),
  Calendar: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 9h18M8 3v4M16 3v4" />
    </svg>
  ),
  Plus: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
};

export default function AppTopbar() {
  const navigate = useNavigate();
  const bellRef = useRef(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const pendingCount = usePendingCount();

  return (
    <div className="cd-topbar">
      <div className="cd-search">
        <Icon.Search />
        <span>Buscar paciente, cita o servicio…</span>
        <kbd>⌘K</kbd>
      </div>
      <div className="cd-topbar-actions">
        <div className="cd-notif-anchor">
          <button
            ref={bellRef}
            type="button"
            className="cd-icon-btn"
            title="Notificaciones"
            aria-haspopup="dialog"
            aria-expanded={notifOpen}
            onClick={() => setNotifOpen((v) => !v)}
          >
            <Icon.Bell />
            {pendingCount > 0 && <span className="cd-dot" aria-label={`${pendingCount} pendientes`} />}
          </button>
          <NotificationsMenu
            open={notifOpen}
            onClose={() => setNotifOpen(false)}
            anchorRef={bellRef}
          />
        </div>
        <button
          type="button"
          className="cd-icon-btn"
          title="Calendario"
          onClick={() => navigate("/calendario")}
        >
          <Icon.Calendar />
        </button>
        <button
          type="button"
          className="cd-btn-primary"
          onClick={() => navigate("/nueva-cita")}
        >
          <Icon.Plus /> Nueva cita
        </button>
      </div>
    </div>
  );
}
